// Clamps a clicked box index to a valid caret position - clicking past the entered code just
// places the caret at the end.
export function clampCaretIndex(index: number, valueLength: number): number {
  return Math.min(index, valueLength);
}

// Finds the box under a click from its real rect, not hardcoded width/gap math - self-corrects
// if that CSS ever changes.
export function findBoxIndexAtX(
  clientX: number,
  boxRects: Array<Pick<DOMRect, 'left' | 'right'> | null>
): number {
  return boxRects.findIndex(
    (rect) => rect !== null && clientX >= rect.left && clientX <= rect.right
  );
}
